{
  "title": "سلامة الدفاتر",
  "intro": "فحوص تبحث عن الأخطاء والأمور المعلّقة في الدفاتر. هي قواعد ثابتة لا ذكاء اصطناعي: الجواب نفسه في كل مرة، ولا يخرج شيء من بيانات الشركة.",
  "period": {
    "label": "الشهر",
    "previous": "الشهر السابق",
    "next": "الشهر التالي"
  },
  "counts": {
    "label": "نتائج الفحص المفتوحة",
    "critical": "حرج",
    "warning": "تحذير",
    "info": "ملاحظة"
  },
  "severity": {
    "critical": "حرج",
    "warning": "تحذير",
    "info": "ملاحظة"
  },
  "showDismissed": "إظهار ما ليس مشكلة",
  "showDismissedCount": "إظهار ما ليس مشكلة ({{n}})",
  "findingsLabel": "نتائج الفحص في {{month}}",
  "since": "منذ {{date}}",
  "records": "السجلات",
  "ran": {
    "today": "جرت الفحوص الساعة {{time}}.",
    "earlier": "جرت الفحوص في {{date}}."
  },
  "empty": {
    "title": "لا نتائج فحص في {{month}}.",
    "dismissedOnly": "لا شيء مفتوح. ما عُدّ ليس مشكلة مخفي: فعّل «إظهار ما ليس مشكلة» لرؤيته."
  },
  "dismissedHeading": "عُدّت ليست مشكلة",
  "dismissed": {
    "byUntil": "عُدّت ليست مشكلة حتى {{date}}، بقرار من {{name}}",
    "byForGood": "عُدّت ليست مشكلة لهذا البند، بقرار من {{name}}",
    "until": "عُدّت ليست مشكلة حتى {{date}}",
    "forGood": "عُدّت ليست مشكلة لهذا البند",
    "undo": "تراجع",
    "undoNamed": "التراجع عن «ليست مشكلة»: {{title}}",
    "undone": "عادت إلى القائمة"
  },
  "dismiss": {
    "open": "ليست مشكلة…",
    "openNamed": "ليست مشكلة: {{title}}",
    "title": "ليست مشكلة",
    "body": "تبقى في القائمة باهتة مع سببك، ولا تُحسب مشكلة مفتوحة. ويمكن لمن يملك هذه الصلاحية التراجع عنها.",
    "reason": "لماذا ليست مشكلة",
    "reasonPlaceholder": "مثال: توريدان في اليوم نفسه، استُلم كلاهما وتمت مراجعتهما.",
    "reasonRequired": "اذكر سبب أنها ليست مشكلة.",
    "howLong": "إلى متى",
    "untilDate": "حتى تاريخ",
    "untilDateBody": "بعد هذا التاريخ تعود إن بقيت قائمة.",
    "forGood": "لهذا البند",
    "forGoodBody": "نهائيًا، على هذه السجلات بعينها. وتُكتشف أي حالة جديدة.",
    "until": "حتى",
    "untilHint": "180 يومًا على الأكثر: حتى {{date}}.",
    "untilInvalid": "اختر تاريخًا من الغد حتى {{date}}.",
    "save": "عدّها ليست مشكلة",
    "saved": "عُدّت ليست مشكلة",
    "notActive": "هذه النتيجة لم تعد قائمة، فلا شيء يُعدّ. حُدّثت القائمة."
  },
  "skipped": {
    "title": "لم يُفحص",
    "disabled": "متوقفة: {{checks}}.",
    "no_permission": "تحتاج صلاحية لا تملكها: {{checks}}.",
    "module_off": "وحدتها متوقفة لشركتك: {{checks}}.",
    "openSettings": "الإعدادات › فحوص الدفاتر",
    "failed": "تعذّر تشغيلها هذه المرة، وجرت الفحوص الأخرى: {{checks}}."
  },
  "loadError": "تعذّر فحص سلامة الدفاتر",
  "action": {
    "purchases": "فتح فواتير الشراء",
    "expenses": "فتح المصروفات",
    "bank": "إجراء التسوية",
    "account": "كشف الحساب",
    "vat": "فتح إقرار الضريبة",
    "balance_sheet": "فتح الميزانية العمومية",
    "journal": "فتح القيد",
    "journals": "فتح القيود اليدوية",
    "drafts": "فتح المسودات",
    "mapping": "ربط الحساب",
    "aging": "أعمار الذمم المدينة",
    "customer": "كشف حساب العميل",
    "lock_date": "ضبط تاريخ الإقفال"
  },
  "kind": {
    "invoices": "فواتير مبيعات",
    "purchases": "فواتير شراء",
    "quotations": "عروض أسعار"
  },
  "side": {
    "debit": "رصيد مدين",
    "credit": "رصيد دائن"
  },
  "subledger": {
    "receivables": "أرصدة العملاء",
    "payables": "أرصدة الموردين",
    "inventory": "تقييم المخزون",
    "cheques_receivable": "الشيكات برسم التحصيل",
    "cheques_payable": "الشيكات الصادرة برسم الدفع"
  },
  "units": {
    "days_zero": "{{n}} يوم",
    "days_one": "يوم واحد",
    "days_two": "يومان",
    "days_few": "{{n}} أيام",
    "days_many": "{{n}} يومًا",
    "days_other": "{{n}} يوم",
    "bills_zero": "{{n}} فاتورة",
    "bills_one": "فاتورة واحدة",
    "bills_two": "فاتورتان",
    "bills_few": "{{n}} فواتير",
    "bills_many": "{{n}} فاتورة",
    "bills_other": "{{n}} فاتورة",
    "expenses_zero": "{{n}} مصروف",
    "expenses_one": "مصروف واحد",
    "expenses_two": "مصروفان",
    "expenses_few": "{{n}} مصروفات",
    "expenses_many": "{{n}} مصروفًا",
    "expenses_other": "{{n}} مصروف",
    "lines_zero": "{{n}} سطر في الكشف",
    "lines_one": "سطر واحد في الكشف",
    "lines_two": "سطران في الكشف",
    "lines_few": "{{n}} أسطر في الكشف",
    "lines_many": "{{n}} سطرًا في الكشف",
    "lines_other": "{{n}} سطر في الكشف",
    "invoices_zero": "{{n}} فاتورة",
    "invoices_one": "فاتورة واحدة",
    "invoices_two": "فاتورتان",
    "invoices_few": "{{n}} فواتير",
    "invoices_many": "{{n}} فاتورة",
    "invoices_other": "{{n}} فاتورة",
    "purchases_zero": "{{n}} فاتورة شراء",
    "purchases_one": "فاتورة شراء واحدة",
    "purchases_two": "فاتورتا شراء",
    "purchases_few": "{{n}} فواتير شراء",
    "purchases_many": "{{n}} فاتورة شراء",
    "purchases_other": "{{n}} فاتورة شراء",
    "quotations_zero": "{{n}} عرض سعر",
    "quotations_one": "عرض سعر واحد",
    "quotations_two": "عرضا سعر",
    "quotations_few": "{{n}} عروض أسعار",
    "quotations_many": "{{n}} عرض سعر",
    "quotations_other": "{{n}} عرض سعر"
  },
  "check": {
    "DUPLICATE_SUPPLIER_BILL": {
      "name": "فواتير موردين مكررة",
      "title": "فاتورة مكررة محتملة من {{supplier}}",
      "detail": "{{count}}، كلٌّ منهما بمبلغ {{total}}، بمرجع المورد نفسه {{reference}}.",
      "detailNoReference": "{{count}}، كلٌّ منهما بمبلغ {{total}}، خلال أيام قليلة من بعضها.",
      "finds": "فاتورتا شراء من المورد نفسه بمرجع المورد نفسه، أو بالإجمالي نفسه خلال أيام قليلة."
    },
    "DUPLICATE_EXPENSE": {
      "name": "مصروفات مكررة",
      "title": "مصروف مكرر محتمل للمستفيد {{payee}}",
      "detail": "{{count}}، كلٌّ منهما بمبلغ {{total}}، خلال أيام قليلة من بعضها.",
      "finds": "مصروفان مرحّلان للمستفيد نفسه وبالمبلغ نفسه خلال أيام قليلة."
    },
    "BANK_NOT_RECONCILED": {
      "name": "حسابات بنكية بلا تسوية",
      "title": "لم تُجرَ تسوية {{account}} منذ {{days}}",
      "detail": "آخر تسوية في {{lastReconciledOn}}، و{{unmatched}} بانتظار المطابقة.",
      "detailNever": "لم تُجرَ له تسوية من قبل، و{{unmatched}} بانتظار المطابقة.",
      "finds": "حساب بنك أو بطاقة أو محفظة آخر كشف مكتمل له قديم، أو أسطر كشف بقيت دون مطابقة."
    },
    "WRONG_SIDE_BALANCE": {
      "name": "أرصدة في غير جانبها",
      "title": "للحساب {{account}} {{side}}",
      "detail": "{{balance}}، في جانب لا يُتوقع لهذا النوع من الحسابات. إن كان حسابًا مقابلًا (مثل مجمع الإهلاك أو مسحوبات المالك) فاعتبره «ليست مشكلة» لهذا الحساب.",
      "finds": "حساب أصول أو مصروفات برصيد دائن، أو حساب التزامات أو حقوق ملكية أو إيرادات برصيد مدين."
    },
    "NEGATIVE_CASH": {
      "name": "نقدية أو بنك بالسالب",
      "title": "رصيد {{account}} بالسالب",
      "detail": "رصيده في نهاية الفترة {{balance}}: خرج أكثر مما دخل.",
      "finds": "حساب نقدية أو بنك برصيد دائن في نهاية الفترة."
    },
    "OPENING_BALANCE_NOT_CLEARED": {
      "name": "أرصدة افتتاحية لم تُصفَّ",
      "title": "أرصدة افتتاحية متبقية في {{account}}",
      "detail": "ما زال فيه {{balance}} بعد الفترة الأولى: انقله إلى الأرباح المحتجزة أو إلى الحسابات الصحيحة.",
      "finds": "رصيد متبقٍّ في حساب الأرصدة الافتتاحية بعد الفترة الأولى."
    },
    "VAT_DIFFERENCE": {
      "name": "فروق إقرار ضريبة القيمة المضافة",
      "title": "إقرار ضريبة القيمة المضافة لا يطابق المستندات",
      "detail": "يختلف الدفتر عن المستندات بمقدار {{difference}} لهذه الفترة.",
      "finds": "أرقام الدفتر في إقرار ضريبة القيمة المضافة لا تطابق مستنداته للفترة."
    },
    "BALANCE_SHEET_UNBALANCED": {
      "name": "ميزانية عمومية غير متوازنة",
      "title": "الميزانية العمومية غير متوازنة",
      "detail": "تختلف الأصول عن الالتزامات وحقوق الملكية بمقدار {{difference}}. لا ينبغي أن يحدث هذا أبدًا: أبلغ مزوّد خدمة سحاب.",
      "finds": "الميزانية العمومية غير متوازنة. لا ينبغي أن يحدث هذا أبدًا."
    },
    "SUBLEDGER_DIFFERENCE": {
      "name": "حسابات رقابة لا تطابق سجلاتها",
      "title": "الحساب {{account}} لا يطابق {{subledger}}",
      "detail": "رصيد الحساب في نهاية الفترة {{balance}}، والفرق {{difference}}. لا ينبغي أن تحرّك هذا الحساب إلا المستندات: ابحث عن قيد رُحِّل إليه بطريقة أخرى.",
      "finds": "حساب ذمم مدينة أو دائنة أو مخزون أو شيكات برسم التحصيل أو الدفع يختلف رصيده عن سجلات العملاء أو الموردين أو المخزون أو الشيكات."
    },
    "LARGE_MANUAL_JOURNAL": {
      "name": "قيود يدوية كبيرة",
      "title": "قيد يدوي {{number}} بمبلغ {{total}}",
      "detail": "يتجاوز حد المراجعة {{threshold}}: يستحق نظرة ثانية.",
      "finds": "قيود يدوية فوق الحد في الفترة، للمراجعة."
    },
    "BACKDATED_ENTRY": {
      "name": "قيود بتاريخ سابق",
      "title": "القيد {{number}} مؤرَّخ قبل ترحيله بـ{{days}}",
      "detail": "تاريخه {{entryDate}} ورُحِّل في {{postedOn}}.",
      "finds": "قيود يدوية مؤرَّخة قبل يوم ترحيلها بمدة طويلة."
    },
    "OLD_DRAFTS": {
      "name": "مسودات قديمة",
      "title": "مسودات قديمة: {{count}}",
      "detail": "{{kind}} بقيت مسودة أطول من الحد؛ أقدمها بتاريخ {{oldestOn}}.",
      "finds": "فواتير مبيعات أو شراء بقيت مسودة أطول من الحد."
    },
    "ROLE_NOT_MAPPED": {
      "name": "أدوار حسابات بلا ربط",
      "title": "لا حساب مربوطًا بدور {{role}}",
      "detail": "لا يمكن ترحيل المستندات التي تستخدمه حتى يُختار له حساب.",
      "finds": "أدوار حسابات تستخدمها وحداتك ولا حساب مربوطًا بها."
    },
    "RECEIVABLES_OVERDUE": {
      "name": "ذمم مدينة تجاوزت 90 يومًا",
      "title": "{{pct}}% من الذمم المدينة تجاوز عمرها 90 يومًا",
      "detail": "{{overdue}} من أصل {{total}} مستحقة على العملاء.",
      "finds": "ذمم مدينة تجاوز عمرها 90 يومًا فوق نسبة من مجموع الذمم."
    },
    "CUSTOMER_CREDIT_BALANCES": {
      "name": "أرصدة دائنة للعملاء",
      "title": "للعميل {{customer}} رصيد دائن {{credit}}",
      "detail": "دفع أكثر مما عليه: رُدّ المبلغ إليه أو طبّقه على فاتورة.",
      "finds": "عملاء دفعوا أكثر مما عليهم، من مبلغ محدد."
    },
    "UNCATEGORISED_SPEND": {
      "name": "مصروفات غير مصنّفة",
      "title": "{{pct}}% من المصروفات غير مصنّفة",
      "detail": "ذهب {{amount}} إلى المصروفات التشغيلية العامة في هذه الفترة.",
      "finds": "مصروفات محمّلة على المصروفات التشغيلية العامة فوق نسبة من مصروفات الفترة."
    },
    "PERIOD_NOT_LOCKED": {
      "name": "أشهر سابقة غير مقفلة",
      "title": "أشهر سابقة ما زالت مفتوحة",
      "detail": "الدفاتر مقفلة حتى {{lockDate}}. أقفلها حتى {{suggested}} بعد مراجعة تلك الأشهر.",
      "detailNoLock": "لا تاريخ إقفال للدفاتر. أقفلها حتى {{suggested}} بعد مراجعة تلك الأشهر.",
      "finds": "تاريخ إقفال متأخر أكثر من شهر كامل."
    }
  },
  "lockWarning": {
    "text": "ما زالت لفحص سلامة الدفاتر نتائج مفتوحة في {{month}} (حرجة: {{critical}}، تحذيرات: {{warning}}). يمكنك الإقفال رغم ذلك، لكن الأفضل معالجتها أولًا.",
    "link": "مراجعة سلامة الدفاتر لشهر {{month}}",
    "impact": "ما زالت لفحص سلامة الدفاتر نتائج مفتوحة في {{month}}: حرجة {{critical}}، تحذيرات {{warning}}."
  },
  "settings": {
    "area": {
      "purchasing": "المشتريات",
      "expenses": "المصروفات",
      "bank": "النقدية والبنوك",
      "ledger": "دفتر الأستاذ",
      "vat": "ضريبة القيمة المضافة",
      "sales": "المبيعات والذمم المدينة",
      "setup": "الإعداد والإقفال"
    },
    "on": "يعمل",
    "off": "متوقف",
    "threshold": {
      "duplicateWindowDays": {
        "label": "المبلغ نفسه خلال",
        "hint": "فاتورتان أو مصروفان خلال {{days}} من بعضهما يُعدّان تكرارًا محتملًا."
      },
      "bankStaleDays": {
        "label": "التحذير بعد",
        "hint": "تحذير بعد {{days}} دون تسوية، وحرج بعد {{twice}}."
      },
      "wrongSideMin": {
        "label": "من رصيد قدره",
        "hint": "الأرصدة الأقل من {{amount}} لا يُنبَّه عليها."
      },
      "openingBalanceMin": {
        "label": "من رصيد قدره",
        "hint": "الأرصدة الأقل من {{amount}} لا يُنبَّه عليها."
      },
      "vatDifferenceMin": {
        "label": "من فرق قدره",
        "hint": "الفروق الأقل من {{amount}} لا يُنبَّه عليها.",
        "hintAny": "يُنبَّه على أي فرق."
      },
      "largeManualJournal": {
        "label": "من إجمالي قدره",
        "hint": "تُعرض القيود اليدوية البالغة {{amount}} فأكثر للمراجعة."
      },
      "backdatedDays": {
        "label": "مؤرَّخ قبل أكثر من",
        "hint": "قيد يدوي مؤرَّخ قبل ترحيله بأكثر من {{days}}."
      },
      "oldDraftDays": {
        "label": "أقدم من",
        "hint": "مسودات بقيت أكثر من {{days}}."
      },
      "receivablesOverduePct": {
        "label": "فوق نسبة",
        "hint": "حين يتجاوز عمر أكثر من {{pct}}% من الذمم المدينة 90 يومًا."
      },
      "customerCreditMin": {
        "label": "من رصيد دائن قدره",
        "hint": "الأرصدة الدائنة الأقل من {{amount}} لا يُنبَّه عليها."
      },
      "uncategorisedPct": {
        "label": "فوق نسبة",
        "hint": "حين يذهب أكثر من {{pct}}% من مصروفات الفترة إلى المصروفات التشغيلية العامة."
      }
    },
    "sharedWindow": "يستخدم المدة نفسها لفواتير الموردين المكررة: {{days}}.",
    "unit": {
      "days": "يوم",
      "pct": "%"
    },
    "range": "عدد صحيح من 0 إلى {{max}}.",
    "amountInvalid": "مبلغ قدره 0 فأكثر، بثلاث خانات عشرية على الأكثر.",
    "invalid": "بعض القيم تحتاج تصحيحًا قبل الحفظ.",
    "save": "حفظ فحوص الدفاتر",
    "saved": "حُفظت فحوص الدفاتر",
    "conflict": "غيّر شخص آخر هذه الفحوص أثناء تعديلك. أعد التحميل لرؤية نسخته.",
    "reload": "إعادة التحميل"
  },
  "truncated": "{{check}}: تُعرض أول {{shown}} من {{total}}، والأعداد تشملها كلها.",
  "draftRef": {
    "sales_invoice": "مسودة فاتورة بتاريخ {{date}}",
    "purchase": "مسودة فاتورة شراء بتاريخ {{date}}",
    "purchaseReference": "مسودة فاتورة شراء {{reference}} بتاريخ {{date}}",
    "other": "مسودة بتاريخ {{date}}"
  }
}
